import React, { useState } from 'react';
import './table.css';

const TableComponent = ({ data, serviceType }) => {
  const [filtreNumLNE, setFiltreNumLNE] = useState('');

  // Mappage isLaboratorized vers texte avec les nouveaux statuts
  const mapLaboStatus = (isLaboratorized) => {
    switch (isLaboratorized) {
      case 0: return "En attente";
      case 1: return "En cours";
      case 2: return "Prélèvement traité";
      case 3: return "Terminé";
      case 4: return "Annulé";
      default: return "En attente";
    }
  };

  // Définition des en-têtes selon le type de service
  const getHeaders = () => {
    const baseHeaders = [
      { key: 'numClient', label: 'No' },
      { key: 'nomClient', label: 'Nom Client' },
      { key: 'numID_LNE', label: 'N° Unique LNE' },
      { key: 'numAirTel', label: 'N° AirTel' },
      { key: 'service', label: 'Service' },
      { key: 'montant', label: 'Total FCFA' },
      { key: 'dateCreation', label: 'Date OP' }
    ];

    if (serviceType === 'laboratoire') {
      // Pour le laboratoire : on ajoute la colonne état labo
      return [
        ...baseHeaders,
        { key: 'isLaboratorized', label: 'État Labo' }
      ];
    } else {
      // Pour les autres services (consultation, etc.)
      return baseHeaders;
    }
  };

  const headers = getHeaders();

  // Filtrer les données par numID_LNE
  const donnéesFiltrées = data.filter(item => 
    filtreNumLNE === '' || 
    (item.numID_LNE && item.numID_LNE.toString().toLowerCase().includes(filtreNumLNE.toLowerCase()))
  );

  // Fonction pour formatter les valeurs
  const formatterValeur = (valeur, key) => {
    if (valeur === null || valeur === undefined || valeur === '') {
      return '-';
    }
    
    if (key === 'isAssured') {
      return valeur ? 'Oui' : 'Non';
    }
    
    if (key === 'isLaboratorized') {
      return mapLaboStatus(valeur);
    }
    
    if (key === 'montant' && typeof valeur === 'number') {
      return `${valeur.toLocaleString('fr-FR')} FCFA`;
    }
    
    if ((key === 'dateCreation' || key === 'dateModification') && valeur) {
      try {
        return new Date(valeur).toLocaleDateString('fr-FR');
      } catch (e) {
        return valeur;
      }
    }
    
    return valeur.toString();
  };

  return (
    <div className="table-container-fullwidth">
      {/* Barre de filtre */}
      <div className="filtre-container">
        <label htmlFor="filtre-csr">Filtrer par N° LNE : </label>
        <input
          id="filtre-csr"
          type="text"
          placeholder="Entrez le numéro LNE..."
          value={filtreNumLNE}
          onChange={(e) => setFiltreNumLNE(e.target.value)}
          className="champ-filtre"
        />
        <span className="nombre-resultats">
          {donnéesFiltrées.length} résultat(s) sur {data.length}
        </span>
      </div>

      {donnéesFiltrées.length > 0 ? (
        <div className="table-wrapper">
          <table className="data-table-fullwidth">
            <thead>
              <tr>
                {headers.map(header => (
                  <th key={header.key}>{header.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {donnéesFiltrées.map((item, index) => (
                <tr key={item.numClient || index}>
                  {headers.map(header => (
                    <td key={header.key}>
                      {formatterValeur(item[header.key], header.key)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="aucune-donnee-tableau">
          {data.length === 0 
            ? 'Aucune donnée à afficher' 
            : `Aucun résultat trouvé pour le numéro LNE : "${filtreNumLNE}"`
          }
        </div>
      )}
    </div>
  );
};

export default TableComponent;